import { cloneDeep, find } from "lodash";
import { useState, useEffect, useRef} from "react";
import { useSelector, useDispatch } from "react-redux";
import { GetGoogleColumns, GoogleConnectionInfo } from "../card-design/GoogleConnectionInfo";
import { GetSupabaseColumns, SupabaseConnectionInfo } from "../card-design/SupabaseConnectionInfo";


export const ConnectionData = ({ setColumnNames, updateElementValue}) => {
  const {
    selectedBlock,
    pageInfo: { blocks },
    projectData: { connections, project_id },
  } = useSelector((state) => state.studioDetails);

  const currentBlock = find(blocks, ["metaDataId", selectedBlock.metaDataId]);

  const connection = find(connections, [
    "connection_id",
    currentBlock.configs.connection.connectionId,
  ]);

  const [connectionType, setConnectionType] = useState("");
  useEffect(() => {
    setConnectionType(connection?.connection_type);
  }, []);

  if(connectionType == "googleSheet"){
    return (<GoogleConnectionInfo
      updateElementValue={updateElementValue}
      setColumnNames={setColumnNames}
      connectionType={connectionType}
      display={false}
    />)
  }else  if(connectionType == "supabase"){
    return (<SupabaseConnectionInfo
      updateElementValue={updateElementValue}
      setColumnNames={setColumnNames}
      connectionType={connectionType}
      display={false}
    />)
  }

  return(<></>)
}

export const GetColumnsData = ({  connection, connectionType, setColumnNames, updateElementValue}) => {
  
  if(connectionType == "googleSheet"){
    return (<GetGoogleColumns
      connection={connection}
      setColumnNames={setColumnNames}
    />)
  }else  if(connectionType == "supabase"){
    return (<GetSupabaseColumns
      connection={connection}
      setColumnNames={setColumnNames}
    />)
  }

  return(<></>)
}
